import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { JwtInterceptor } from '../shared/guards/jwt.interceptor';
import { AuthCoreModule } from '../core/auth-core/auth-core.module';
import { SharedModule } from '../shared/shared.module';
import { HeaderInterceptor } from '../shared/guards/header-interceptor';
import { SettingsComponent } from './settings.component';
import { AppRoutingModule } from '../app-routing.module';

@NgModule({
  declarations: [SettingsComponent],
  imports: [CommonModule, AuthCoreModule, SharedModule , AppRoutingModule],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HeaderInterceptor,
      multi: true,
    },
  ],
})
export class SettingsModule {}
